import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';
import type { Permission } from 'owa-graph-schema';

export interface GET_FOLDER_PERMISSIONSActionMessage {
    folderId: string;
}

export interface UPDATE_FOLDER_PERMISSIONSActionMessage {
    folderIds: string[];
}

/**
 * Action to dispatch success status for fetch folder permissions request.
 */
export const getFolderPermissionsSuccess: (
    folderId: string
) => GET_FOLDER_PERMISSIONSActionMessage = action(
    'GET_FOLDER_PERMISSIONS_SUCCESS',
    (folderId: string): GET_FOLDER_PERMISSIONSActionMessage => {
        return { folderId };
    }
);

/**
 * Action to dispatch failure status for fetch folder permissions request.
 */
export const getFolderPermissionsFailed: (folderId: string) => GET_FOLDER_PERMISSIONSActionMessage =
    action(
        'GET_FOLDER_PERMISSIONS_FAILED',
        (folderId: string): GET_FOLDER_PERMISSIONSActionMessage => {
            return { folderId };
        }
    );

/**
 * Action to update folder permissions in store.
 * @param folderId Id of the folder
 * @param permissions Permissions defined on the folder
 */
export interface UpdateFolderPermissionsItem {
    folderId: string;
    permissions: Permission[];
    mailboxInfo: MailboxInfo;
}

/**
 * Action to dispatch success status for update folder permissions request.
 */
export const updateFolderPermissionsSuccess: (
    folderIds: string[]
) => UPDATE_FOLDER_PERMISSIONSActionMessage = action(
    'UPDATE_FOLDER_PERMISSIONS_SUCCESS',
    (folderIds: string[]): UPDATE_FOLDER_PERMISSIONSActionMessage => {
        return { folderIds };
    }
);

/**
 * Action to dispatch failure status for update folder permissions request.
 */
export const updateFolderPermissionsFailed: (
    folderIds: string[]
) => UPDATE_FOLDER_PERMISSIONSActionMessage = action(
    'UPDATE_FOLDER_PERMISSIONS_FAILED',
    (folderIds: string[]): UPDATE_FOLDER_PERMISSIONSActionMessage => {
        return { folderIds };
    }
);

export interface InitializeFolderTreeCompletedActionMessage {
    mailboxInfo: MailboxInfo;
}

export const onInitializeFolderTreeCompleted: (
    mailboxInfo: MailboxInfo
) => InitializeFolderTreeCompletedActionMessage = action(
    'ON_INITIALIZE_FOLDER_TREE_COMPLETED',
    (mailboxInfo: MailboxInfo): InitializeFolderTreeCompletedActionMessage => {
        return { mailboxInfo };
    }
);

export interface INITIALIZE_FOLDER_VIEW_STATESActionMessage {
    folderIds: string[];
}

export const initializeFolderViewStates: (
    folderIds: string[]
) => INITIALIZE_FOLDER_VIEW_STATESActionMessage = action(
    'INITIALIZE_FOLDER_VIEW_STATES',
    (folderIds: string[]): INITIALIZE_FOLDER_VIEW_STATESActionMessage => {
        return { folderIds };
    }
);
